import { useEffect, useState } from "react";
import { BasicButton } from "../../theme/Component/BasicButton";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { ListMenu } from "../../theme/Component/ListMenu";
import { toast } from "react-toastify";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { _Fingerprint, _RelationshipByOwner } from "../../../core/services/dataBean/EntityCatalogVdos";
import { AccountEditor } from "../../editor/AccountEditor";
import { RelationshipTypeEditor } from "../../Talentohumano/ParametrosTalentoHumano/RelationshipType/RelationshipTypeEditor";
import { RelationshipClassConstants } from "./RelationshipClassConstants";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
import { FileInput } from "../../theme/Component/FileInput";

import { FingerType } from "./FingerType";
import { HandleTypes } from "./HandleTypes";
import { FileService } from "../../../core/services/FileService";




interface Props {
    accountID: number;
}

export const Fingerprint = ({ accountID }: Props) => {

    const finger = useDataBean(_Fingerprint);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const fileService = new FileService();
    const [Type, setType] = useState<any>(null)
    const [modalentity, setModalentity] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modaltype, setModaltype] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [accountID])

    const getLista = () => {

        finger.instance.getFingerprint(accountID).then(
            (resp: any) => {
                if (resp) {
                    let tmp = resp;
                    tmp.forEach((element: any) => {
                        if (element.DataBeanProperties.MediaContext) {
                            element.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media)}" target='_blank'>DESCARGAR DOCUMENTO</a>`
                        } else {
                            element.DataBeanProperties.URL = "Sin Documento";
                        }
                    });
                    setLista(tmp);
                } else {
                    setLista([]);
                }
            }
        )

    }

    const create = () => {
        finger.setBean({
           
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        finger.instance.deleteBioIdentity(finger.bean.IDBioIdentity).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const addFingerprint = () => {
        
        finger.instance.addFingerprint(accountID,finger.bean.HandType,finger.bean.FingerType,finger.bean.Media,finger.bean.MediaContext,null).then(
            (resp: any) => {
                console.log(resp)
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    
    const head = [
        { title: 'ID', property: 'IDBioIdentity', visible: true },
        { title: 'Mano', property: 'HandTypeName', visible: true },
        { title: 'Dedo', property: 'FingerTypeName', visible: true },
        { title: 'Archivo de Imágen', property: 'URL', visible: true },
        { title: 'Creado', property: 'Since', visible: true },
        
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <label>Huellas Digitales</label>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={finger.setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={addFingerprint}>
                    <div className="row">
                       <div className="col-md-12">
                        <FileInput
                                          Media={finger.bean.Media}
                                          MediaContext={finger.bean.MediaContext}
                                          directory='Rate'
                                          label='Archivo'
                                          docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                        onCreate={(Filemap: any) => { finger.setBean({ ...finger.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                        ></FileInput>
                    </div>
                    <div className="col-md-6">
                        <HandleTypes idSelector={finger.bean.HandType} onChange={(e) => { finger.setBean({ ...finger.bean, "HandType": e }) }}/>
                    </div>
                    <div className="col-md-6">
                        <FingerType idSelector={finger.bean.FingerType} onChange={(e) => { finger.setBean({ ...finger.bean, "FingerType": e }) }}/>
                    </div>
                    </div>
                </Modal>
                
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}